<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import AsyncSelect from '$components/Form/AsyncSelect.svelte';

    import {
        loadOptions,
        optionToValue,
        valueToId,
        valueToOption,
    } from '$components/Form/SelectCompany/utils';
    import MediaImageOrPlaceholder from '$lib/components/MediaImage/MediaImageOrPlaceholder.svelte';
    import type { Strategy } from '@floating-ui/utils';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, number | null>;
    export let placeholder: string = 'Société';
    export let defaultClass: string | undefined = undefined;
    export let showChevron = false;
    export let id: string | null = null;
    export let floatingStrategy: Strategy | undefined = undefined;

    let className: string = '';
    export { className as class };

    const { apollo } = getContainer();
</script>

<AsyncSelect
    {defaultClass}
    class={className}
    {form}
    {field}
    {placeholder}
    {showChevron}
    {id}
    {floatingStrategy}
    loadOptions={(q) => loadOptions(apollo, q)}
    {optionToValue}
    valueToOption={(v) => valueToOption(apollo, v)}
    {valueToId}
    optionId="id"
    label="participantName"
>
    <div
        slot="option"
        let:option
        class="flex gap-[8px] py-[4px] pr-[8px] pl-[16px] rounded-[8px] w-full max-w-full items-center"
    >
        <MediaImageOrPlaceholder
            class={'force-w-[42px] force-h-[42px] object-cover shrink-0'}
            format="w300"
            mediaId={option.participantPhoto?.id}
        />
        <div class="grow flex flex-col pr-[10px] min-w-0 max-w-full">
            <div
                class="whitespace-normal line-clamp-2 font-normal text-13/[18px] tracking-[-1%] text-black"
            >
                {option.participantName}
            </div>
            <div
                class="whitespace-normal line-clamp-2 font-normal text-12/[18px] tracking-[-1%] text-gray-650"
            >
                {option.participantTitle ?? ''}
            </div>
        </div>
    </div>
</AsyncSelect>
